import { Briefcase, Star, Award, Flame, Trophy, Lock } from 'lucide-react';

const iconMap = {
  briefcase: Briefcase,
  star: Star,
  award: Award,
  flame: Flame,
  trophy: Trophy,
};

const categoryColors = {
  deals: 'text-green-400 bg-green-400/10 border-green-400/20',
  reputation: 'text-brand-gold bg-brand-gold/10 border-brand-gold/20',
  consistency: 'text-orange-400 bg-orange-400/10 border-orange-400/20',
};

const ALL_ACHIEVEMENTS = [
  { key: 'first_deal', name: 'First Deal', desc: 'Closed your first deal', icon: 'briefcase', category: 'deals' },
  { key: '5_deals', name: '5 Deals Closed', desc: 'Closed 5 deals', icon: 'briefcase', category: 'deals' },
  { key: '10_deals', name: '10 Deals Closed', desc: 'Closed 10 deals', icon: 'briefcase', category: 'deals' },
  { key: '25_deals', name: '25 Deals Closed', desc: 'Closed 25 deals', icon: 'trophy', category: 'deals' },
  { key: 'first_review', name: 'First Review', desc: 'Received your first review', icon: 'star', category: 'reputation' },
  { key: '10_reviews', name: '10 Reviews', desc: 'Received 10 reviews', icon: 'star', category: 'reputation' },
  { key: 'high_rating', name: 'Top Performer', desc: 'Maintain 4.5+ rating with 5+ reviews', icon: 'award', category: 'reputation' },
  { key: 'streak_3', name: '3-Month Streak', desc: '3 consecutive months with deals', icon: 'flame', category: 'consistency' },
  { key: 'streak_6', name: '6-Month Streak', desc: '6 consecutive months with deals', icon: 'flame', category: 'consistency' },
];

const AchievementGrid = ({ achievements = [] }) => {
  const unlockedKeys = new Set(achievements.map(a => a.key));
  const unlockedCount = unlockedKeys.size;

  return (
    <div className="rounded-xl border border-white/10 bg-[#111317] p-5" data-testid="achievements-section">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Trophy className="w-5 h-5 text-brand-gold" />
          <h3 className="text-sm font-semibold text-brand-text">Achievements</h3>
        </div>
        <span className="text-xs text-zinc-500">{unlockedCount}/{ALL_ACHIEVEMENTS.length}</span>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {ALL_ACHIEVEMENTS.map((ach) => {
          const unlocked = unlockedKeys.has(ach.key);
          const Icon = unlocked ? (iconMap[ach.icon] || Award) : Lock;
          const colors = unlocked ? categoryColors[ach.category] : 'text-zinc-600 bg-zinc-800/50 border-zinc-700/50';

          return (
            <div
              key={ach.key}
              data-testid={`achievement-${ach.key}`}
              className={`relative rounded-lg border p-3 text-center transition-all ${colors} ${unlocked ? '' : 'opacity-40'}`}
              title={`${ach.name}: ${ach.desc}`}
            >
              <Icon className={`w-5 h-5 mx-auto mb-1.5 ${unlocked ? '' : 'text-zinc-600'}`} />
              <div className={`text-[11px] font-medium leading-tight ${unlocked ? '' : 'text-zinc-600'}`}>
                {ach.name}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AchievementGrid;
